import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { filter, tap } from 'rxjs/operators';
import { BillExplanationType } from '../../models/extra-cost.model';
import { Store } from '@ngrx/store';
import { ApplicationState } from 'src/app/state/reducers';
import { selectCustomerAccount } from 'src/app/state/selectors/customer-account.selector';
import { OnDestroyHookDirective } from '../../common/hooks';
import { LanguageService } from '@dch/ng-common';

@Component({
  selector: 'my-bill-explanation',
  templateUrl: './explanation.component.html',
  standalone: false,
})
export class ExplanationComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  readonly selectedCustomerAccount$ = this.store.select(selectCustomerAccount);
  billExplanationType: BillExplanationType;
  segment: string;
  topImageUrl: string;
  topImageUrlForSmall: string;

  constructor(
    private route: ActivatedRoute,
    private store: Store<ApplicationState>,
    private languageService: LanguageService
  ) {
    super();
  }

  ngOnInit() {
    this.route.params
      .pipe(
        filter(({ explanationType }) => explanationType !== undefined),
        tap(({ explanationType }) => {
          this.billExplanationType = explanationType;
        })
      )
      .subscribe();

    this.addSubscription(
      this.store
        .select(selectCustomerAccount)
        .pipe(
          filter((customerAccount) => customerAccount !== undefined),
          tap((customerAccount) => {
            this.segment = customerAccount.getSegment();
            this.setTopImagesTranslationKeys();
          })
        )
        .subscribe()
    );
  }

  private setTopImagesTranslationKeys() {
    if (this.billExplanationType === 'firstInvoice') {
      const imageUrl = 'bills.billExplanations.firstInvoice.imagesByLanguage.';
      switch (this.languageService.getSelectedLanguage()) {
        case 'fr':
          this.topImageUrl = `${imageUrl}FR.topImageUrl${this.segment}`;
          this.topImageUrlForSmall = `${imageUrl}FR.topImageUrlForSmall${this.segment}`;
          break;
        case 'nl':
          this.topImageUrl = `${imageUrl}NL.topImageUrl${this.segment}`;
          this.topImageUrlForSmall = `${imageUrl}NL.topImageUrlForSmall${this.segment}`;
          break;
        case 'de':
          this.topImageUrl = `${imageUrl}DE.topImageUrl${this.segment}`;
          this.topImageUrlForSmall = `${imageUrl}DE.topImageUrlForSmall${this.segment}`;
          break;
        default:
          this.topImageUrl = `${imageUrl}EN.topImageUrl${this.segment}`;
          this.topImageUrlForSmall = `${imageUrl}EN.topImageUrlForSmall${this.segment}`;
          break;
      }
    } else {
      this.topImageUrl = `bills.billExplanations.${this.billExplanationType}.topImageUrl`;
      this.topImageUrlForSmall = `bills.billExplanations.${this.billExplanationType}.topImageUrlForSmall`;
    }
  }
}
